// extracted by mini-css-extract-plugin
export var articleContent = "ArticleContent-module--articleContent--f0909";
export var embedlyCard = "ArticleContent-module--embedly-card--54e02";